import { INotificacionErrorUI, NotificacionErrorUI } from "@/core/model/notificacion-ui/INotificacionUI";
import { useMessagesUiStore } from "@/core/stores/messages-ui-store";
import { useServicesFactoryStore } from "@/core/stores/services-factory-store";
import AppUIManagerService from "../AppUIManagerService";

export default function(error: any)
{
 try
 {
  const serviceFactory = useServicesFactoryStore();
  const messagesUiStore = useMessagesUiStore();
  const NotiError: INotificacionErrorUI = new NotificacionErrorUI(error);
  const uiManager:AppUIManagerService = serviceFactory.getAppUIManagerService;
  if(NotiError)
  {
    const alert = serviceFactory.getAlertifyService;    
    messagesUiStore.AddError(NotiError);
    if(alert)
    {
     alert.Error(NotiError.Message);
    }    
  }
  //visible only dev  
  if(IsDebugMode())  
  {
    console.log(error);
  }
  if(uiManager)
  uiManager.removeLoadingUi();
 }
 catch(errorCatch:any)
 {    
    if(IsDebugMode())  
  {
    console.log(errorCatch);
  }
 }
}
export function IsDebugMode()
{
    return process.env.NODE_ENV === 'development' || process.env.VUE_APP_BUILD === 'dev';
}